import React, { FC } from "react";
import propTypes from "prop-types";
import {
    FiUser,
    FiChevronRight,
    FiArrowRightCircle
} from 'react-icons/fi';
import { IoMdCar } from 'react-icons/io';
import CarCrashIcon from "@mui/icons-material/CarCrash";

import { AssetMovement, AssetType } from "../../../../logic/api";

import styles from "./styles";
import flex from "../../../../styles/flex";

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import { formatVehicle, locationPathTextToFriendly } from "../../../../utility/utils";
import { useDate } from "../../../../utility/useDate";
import { useTranslation } from "react-i18next";

const MovementListItem: FC<{ item: AssetMovement, onClick?: () => void }> = (props) => {
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();
    const border = styles.border

    return <div style={{ ...styles.listItem, ...border }} onClick={() => {
        if (props.onClick != null) {
            props.onClick();
        }
    }}>
        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            {props.item.assetType == AssetType.vehicle && (
                <span>{t("workflow.vehicleMove")}</span>
            )}
            {props.item.assetType == AssetType.vehicleKey && (
                <span>{t("lists.keyMove")}</span>
            )}
        </div>
        <div style={styles.listItemFlex}>

            {props.item.assetType == AssetType.vehicle && (
                <ListViewItemCard
                    icon={<FiArrowRightCircle style={styles.icon} />}
                    text={props.item.location.name}
                    subText={locationPathTextToFriendly(props.item.location.pathText)}
                />
            )}
            {props.item.assetType == AssetType.vehicleKey && (
                <ListViewItemCard
                    icon={<FiArrowRightCircle style={styles.icon} />}
                    text={props.item.location.name}
                    subText={locationPathTextToFriendly(props.item.location.pathText)}
                />
            )}
            <ListViewItemCard
                icon={props.item.booking.auditIssueCount ? <CarCrashIcon style={{ ...styles.icon, color: "rgb(235, 48, 79)" }} /> : <IoMdCar style={styles.icon} />}
                text={props.item.booking.vehicle.registration}
                subText={formatVehicle(props.item.booking.vehicle)}
            />

            <ListViewItemCard
                icon={<FiUser style={styles.icon} />}
                text={`${props.item.movedBy.firstName} ${props.item.movedBy.lastName}`}
                subText={toFormattedDateTimeString(new Date(props.item.movementDate))}
            />
            <div style={flex.flexAuto}>
                <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                    <div style={flex.flexAuto}>
                        <FiChevronRight style={styles.iconChevron} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


MovementListItem.propTypes = {
    item: propTypes.any.isRequired,
    onClick: propTypes.func
};


export default MovementListItem;
